/**
 * get the parameters from the url and then structure into an object.
 * @return {Object} see example above
 */
const getUrlParams = () => {
  const params = window.location.search;
  if (params) {
    const urlParams = params
      .slice(1, params.length)
      .split("&")
      .reduce((prev, item) => {
        const paramResults = item.split("=");
        prev[paramResults[0]] = paramResults[1];
        return prev;
      }, {});
    return urlParams;
  } else {
    return false;
  }
};

export default getUrlParams;
